// extracted by mini-css-extract-plugin
export default {"container":"_3DIb","loading":"_2S0s","subHeading":"_1Sk2"};